var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import ElementConfig, { DropdownOption } from '../classes/definitions/formItem/ElementConfig';
import FormItem from '../classes/definitions/formItem/FormItem';
var getHoursInDropdownArray = function () {
    return __spreadArrays(Array.from(Array(24).keys())).map(function (n) {
        var label = 9 < n ? n + ":00" : "0" + n + ":00";
        return new DropdownOption({
            label: label,
            value: n,
        });
    });
};
var slideSchema = {
    link: new FormItem({
        elementConfig: new ElementConfig({
            className: 'form-control',
            type: 'text',
        }),
        elementType: 'input',
        label: 'Линк *',
        value: '',
        validation: {
            required: true,
        },
        valid: false,
        touched: false,
        errorMsg: 'Моля, въвдете валиден линк',
    }),
    position: new FormItem({
        elementConfig: new ElementConfig({
            className: 'form-control',
            type: 'number',
        }),
        elementType: 'input',
        label: 'Позиция',
        value: 50,
        validation: {
            required: false,
        },
        valid: true,
        touched: true,
        errorMsg: 'Моля, въведете валидна позиция',
    }),
    from_date: new FormItem({
        elementConfig: new ElementConfig({
            className: 'form-control',
            dateFormat: 'yy-mm-dd',
        }),
        elementType: 'datepicker',
        label: 'От дата',
        value: '',
        validation: {
            required: false,
        },
        valid: true,
        touched: true,
        errorMsg: 'Моля, въведете начална дата',
    }),
    from_date_hour: new FormItem({
        elementConfig: new ElementConfig({
            className: 'form-control',
            type: 'number',
            options: getHoursInDropdownArray(),
        }),
        elementType: 'dropdown',
        label: 'От час',
        value: 0,
        validation: {
            required: false,
        },
        valid: true,
        touched: true,
        errorMsg: 'Моля, въведете начален час',
    }),
    to_date: new FormItem({
        elementConfig: new ElementConfig({
            className: 'form-control',
            dateFormat: 'yy-mm-dd',
        }),
        elementType: 'datepicker',
        label: 'До дата',
        value: '',
        validation: {
            required: false,
            dateBefore: 'from_date',
        },
        valid: true,
        touched: false,
        errorMsg: 'Моля, въведете крайна дата',
    }),
    to_date_hour: new FormItem({
        elementConfig: new ElementConfig({
            className: 'form-control',
            type: 'number',
            options: getHoursInDropdownArray(),
        }),
        elementType: 'dropdown',
        label: 'До час',
        value: 0,
        validation: {
            required: false,
        },
        valid: true,
        touched: false,
        errorMsg: 'Моля, въведете краен час',
    }),
    countdown: new FormItem({
        elementConfig: new ElementConfig({
            className: 'form-control',
        }),
        elementType: 'checkbox',
        label: 'Часовник',
        value: false,
        validation: {
            required: false,
        },
        valid: true,
        touched: false,
        errorMsg: '',
    }),
    subscribe: new FormItem({
        elementConfig: new ElementConfig({
            className: 'form-control not-show',
        }),
        elementType: 'checkbox',
        label: 'Абонамент',
        value: false,
        validation: {
            required: false,
        },
        valid: true,
        touched: false,
        errorMsg: '',
    }),
    image: new FormItem({
        elementConfig: new ElementConfig({
            className: 'form-control',
        }),
        elementType: 'image',
        label: 'Картинка',
        value: null,
        validation: {
            required: true,
        },
        valid: false,
        touched: false,
        errorMsg: 'Моля, въвдете картинка за слайда',
    }),
    mobile_image: new FormItem({
        elementConfig: new ElementConfig({
            className: 'form-control not-show',
        }),
        elementType: 'image',
        label: 'Картинка за Мобилен Слайдер',
        value: null,
        validation: {
            required: false,
        },
        valid: true,
        touched: false,
        errorMsg: 'Моля, въвдете картинка за слайда',
    }),
    seo_name: new FormItem({
        elementConfig: new ElementConfig({
            className: 'form-control',
            type: 'text',
        }),
        elementType: 'input',
        label: 'Име на слайдера*',
        value: '',
        validation: {
            required: false,
        },
        valid: false,
        touched: false,
        errorMsg: 'Моля, въвдете валиден име',
    }),
    video_idx: new FormItem({
        elementConfig: new ElementConfig({
            className: 'form-control',
            type: 'text',
        }),
        elementType: 'input',
        label: 'ID на видео слайдер',
        value: '',
        validation: {
            required: false,
        },
        valid: false,
        touched: false,
        errorMsg: 'Моля, въвдете валидено id',
    }),
};
export default slideSchema;



//////////////////
// WEBPACK FOOTER
// ./src/schemas/slideSchema.ts
// module id = 125
// module chunks = 0